// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__29Uvc","requiredAsterisk":"Info_requiredAsterisk__2bQ46"};